import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { redirect } from 'redux-first-router';
import { css } from '@emotion/core';
import { ROUTE_HOMEPAGE } from '../../../../ReduxStorage/routeActions';
import { WindowSizePropType } from '../../../../CustomPropTypes/BrowserPropTypes';
import { PortalInstitutionPropType } from '../../../../CustomPropTypes/PortalPropTypes';
import { PortalTopBar } from '../../PortalTopBar/PortalTopBar';
import { PortalFooter } from '../../PortalFooter/PortalFooter';
import { MIN_NAV_BAR_WINDOW_WIDTH } from '../../PortalShared';

import './styles.scss';

class _AccessRestrictedPage extends React.PureComponent {
  static propTypes = {
    portalInstitution: PortalInstitutionPropType.isRequired,
    windowSize: WindowSizePropType.isRequired,
    redirectToOpenLearning: PropTypes.func.isRequired,
  };

  render() {
    const {
      portalInstitution,
      windowSize,
      redirectToOpenLearning,
    } = this.props;

    const showMobileNavBar =
      windowSize && windowSize.outerWidth < MIN_NAV_BAR_WINDOW_WIDTH;

    const backgroundColor = portalInstitution.getIn([
      'themeData',
      'brand-color-dark',
    ]);

    return (
      <div className="portal-institution-page" css={css({ backgroundColor })}>
        <PortalTopBar {...{ portalInstitution, showMobileNavBar }} pageReady />
        <div className="portal-body">
          <div className="access-restricted">
            <h3>Access Restricted</h3>
            <p>
              Your account is not registered with{' '}
              <strong>{portalInstitution.get('institutionName')}</strong>. If
              you think you should have access, please contact your course
              administrator.
            </p>
            <button
              type="button"
              css={css({
                backgroundColor: portalInstitution.getIn([
                  'themeData',
                  'cta-color',
                ]),
              })}
              onClick={redirectToOpenLearning}
            >
              Back to OpenLearning
            </button>
          </div>
        </div>
        <PortalFooter footerData={portalInstitution.get('footer')} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    redirectToOpenLearning: () =>
      dispatch(
        redirect({
          type: ROUTE_HOMEPAGE,
        })
      ),
  };
};

export const AccessRestrictedPage = connect(
  null,
  mapDispatchToProps
)(_AccessRestrictedPage);
